import { c as _c } from "react/compiler-runtime";
export default function SubstackIcon() {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <circle cx="45" cy="45" r="45" fill="#FF6719" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <g clipPath="url(#clip0_377_2269)"><path d="M65.9982 31.8125H24V37.4855H65.9982V31.8125Z" fill="white" /><path d="M24 42.625V69.0008L44.9982 57.2214L66 69.0008V42.625H24Z" fill="white" /><path d="M65.9982 21H24V26.6721H65.9982V21Z" fill="white" /></g>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <svg className="tw-w-full tw-h-full tw-align-top" viewBox="0 0 90 90" fill="none" xmlns="http://www.w3.org/2000/svg">{t0}{t1}<defs><clipPath id="clip0_377_2269"><rect width="42" height="48" fill="white" transform="translate(24 21)" /></clipPath></defs></svg>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}